import axios from 'axios/dist/axios';
import { stringify } from 'qs';
import initApi from './initapi.js'
let V3_BASE_URL = '';
let MARKET_BASE_URL = '';
let WX_BIND_BASE_URL = '';
let HEADERS = {};
let COMMON_BODY = {};
let BIZ_ID = 2
//是否同源
let isHomologous = false;
const INTERCEPTORS_REQUEST = {
  SUCCESSFULHANDLERS: [],
  FAILEDHANDLERS: [],
}; //请求回调
const INTERCEPTORS_RESPONSE = {
  SUCCESSFULHANDLERS: [],
  FAILEDHANDLERS: [],
}; //响应回调

function setBaseUrl(options) {
  console.log('---V3_BASE_URL----', options);
  V3_BASE_URL = options.v3Url;
  WX_BIND_BASE_URL = options.wxBindBaseUrl;
  MARKET_BASE_URL = options.marketUrl;
  isHomologous = options.isHomologous;
  BIZ_ID = options.bizId || 2;
}
function getBaseUrl() {
  return {
    V3_BASE_URL
  }
}
function setRequestHeaders(options) {
  Object.assign(HEADERS, options);
  // console.log(HEADERS, '---HEADERS');
}

// 返回当前请求头设置的platform 判断当前的使用的端
function getPlatform() {
  return HEADERS['platform']
}

function setRequestBody(options) {
  Object.assign(COMMON_BODY, options);
}

//设置请求拦截器
function setRequestInterceptors(successfulHandlers, failedHandlers) {
  if (successfulHandlers && typeof successfulHandlers == 'function') {
    INTERCEPTORS_REQUEST.SUCCESSFULHANDLERS.push(successfulHandlers)
  }
  if (failedHandlers && typeof failedHandlers == 'function') {
    INTERCEPTORS_REQUEST.FAILEDHANDLERS.push(failedHandlers)
  }
}

//设置响应拦截器
function setResponseInterceptors(successfulHandlers, failedHandlers) {
  if (successfulHandlers && typeof successfulHandlers == 'function') {
    INTERCEPTORS_RESPONSE.SUCCESSFULHANDLERS.push(successfulHandlers)
  }
  if (failedHandlers && typeof failedHandlers == 'function') {
    INTERCEPTORS_RESPONSE.FAILEDHANDLERS.push(failedHandlers)
  }
}

//清空请求拦截器
function clearRequestInterceptors() {
  INTERCEPTORS_REQUEST.SUCCESSFULHANDLERS = []
  INTERCEPTORS_REQUEST.FAILEDHANDLERS = []
}

//清空响应拦截器
function clearResponseInterceptors() {
  INTERCEPTORS_RESPONSE.SUCCESSFULHANDLERS = []
  INTERCEPTORS_RESPONSE.FAILEDHANDLERS = []
}


const service = axios.create({ headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, withCredentials: false });

// request interceptor
service.interceptors.request.use(
  config => {
    if (isHomologous && initApi[config.url]) {
      config.baseURL = ''
    } else if (config.url.indexOf("/v3/commons/auth/weixin-ajax") != -1) {
      //TODO: test4 由于微信只能在测试环境跑通, 所以授权暂时指定到test环境
      config.baseURL = WX_BIND_BASE_URL;
    } else if (config.url.startsWith('/v1/marketing')) {
      // 新内容营销中心的接口，预发布环境需要区分域名
      config.baseURL = MARKET_BASE_URL;
    } else {
      // set baseURL
      config.baseURL = V3_BASE_URL;
    }

    config.headers = {
      'interact-token': window.interact_token || sessionStorage.getItem('interact_token') || '',
      ...HEADERS,
      ...config.headers,
      zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      'Request-Id': 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      })
    };
    //角色登录页面登录，无论本地是否存在token，前端请求接口都不携带token。
    if (config.url.indexOf("/live/role-login") != -1) {
      config.headers.token = ''
    }
    if (config.data?.biz_id) {
      config.data.biz_id = BIZ_ID
    }
    if (config.params?.biz_id) {
      config.params.biz_id = BIZ_ID
    }
    if (config.headers['Content-Type'] === 'multipart/form-data') {
      if (config.data && typeof config.data === 'object' && !(config.data instanceof FormData)) {
        const params = config.data;
        const formData = new FormData();
        Object.keys(params).forEach(key => {
          formData.append(key, params[key]);
        });
        config.data = formData;
      }
    } else {
      if (typeof config.data === 'string') {
        config.data = (config.data && JSON.parse(config.data)) || {};
      }

      config.data = {
        ...COMMON_BODY,
        ...config.data
      };

      // 如果有 live_token 就不需要传 token
      if (config.data.live_token) {
        delete config.headers.token;
      }

      if (config.data &&
        typeof config.data === 'object' &&
        config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        config.data = stringify(config.data);
      }

      // get 请求处理通用请求体
      if (config.method == 'get') {
        config.params = {
          ...COMMON_BODY,
          ...config.params
        }
      }

    }

    //执行自定义请求回调
    // console.log('INTERCEPTORS_REQUEST ->', INTERCEPTORS_REQUEST)
    INTERCEPTORS_REQUEST.SUCCESSFULHANDLERS.map(func => {
      let rqs = func(config) || {}
      Object.assign(config, rqs);
    })
    // console.log('---请求拦截----', config);
    return config;
  },
  error => {
    //执行自定义请求回调
    INTERCEPTORS_REQUEST.FAILEDHANDLERS.map(func => {
      let rqs = func(error) || {}
      Object.assign(error, rqs);
    })
    return Promise.reject((error instanceof Error) ? error.toJSON() : error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    //执行自定义响应回调
    // console.log('INTERCEPTORS_RESPONSE ->', INTERCEPTORS_RESPONSE)
    INTERCEPTORS_RESPONSE.SUCCESSFULHANDLERS.map(func => {
      let rps = func(response) || {}
      Object.assign(response, rps);
    })
    return response.data;
  },
  error => {
    //执行自定义请求回调
    INTERCEPTORS_RESPONSE.FAILEDHANDLERS.map(func => {
      let rps = func(error) || {}
      Object.assign(error, rps);
    })
    return Promise.reject((error instanceof Error) ? error.toJSON() : error);
  }
);

export default service;
export { setBaseUrl, setRequestHeaders, setRequestBody, getPlatform, setRequestInterceptors, setResponseInterceptors, clearRequestInterceptors, clearResponseInterceptors, getBaseUrl };
